import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  ADD_CONDITION_BUTTON: `${cleanedFilename(__filename)}-add-condition-button`,
  VARIABLE_REP: `${cleanedFilename(__filename)}-variable-rep`,
};
